import { formatMoney } from "infra/helpers/number";
import { useMemo } from "react";
import { PDFTableColumn } from "components/PDF/Table";
import { View, Text } from "@react-pdf/renderer";
import { CobrancaContaItemComposicao } from "core/features/cobranca/typings";

function useRelatorioCobrancasPdfColumns(): PDFTableColumn<CobrancaContaItemComposicao>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<CobrancaContaItemComposicao>[] = [];

    columns.push({
      title: "Categoria",
      flexGrow: 2.5,
      render: (original) => (
        <View>
          <Text>{original.nome}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Original",
      textAlign: "right",
      flexGrow: 1,
      render: (original) => (
        <View>
          <Text>{formatMoney(original.valorOriginal)}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Multa",
      flexGrow: 0.8,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{formatMoney(original.multa)}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Juros",
      flexGrow: 0.8,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{formatMoney(original.juros)}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Tx. Cobrança",
      flexGrow: 1.6,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{formatMoney(original.valorTaxaCobranca)}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Correção Monetária",
      flexGrow: 1,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{formatMoney(original.atualizacaoMonetaria)}</Text>
        </View>
      ),
    });

    // columns.push({
    //   title: "Honorários",
    //   flexGrow: 1,
    //   textAlign: "right",
    //   render: (original) => (
    //     <View>
    //       <Text>{formatMoney(original.honorarios)}</Text>
    //     </View>
    //   ),
    // });

    columns.push({
      title: "Total",
      flexGrow: 1,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{formatMoney(original.total)}</Text>
        </View>
      ),
    });
    return columns;
  }, []);
}

export default useRelatorioCobrancasPdfColumns;
